<template>
    <fragment>
    <nav class="navbar">
            <div class="nav-wrapper">
              <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons">menu</i></a>
            <router-link to="/home" style="margin-left:10%;" class="brand-logo">
              Main Page
            </router-link>
              <ul class="sidenav" id="mobile-demo">
                <div class="banner">
                  <img src="http://kakehashi-education-center.com/images/kakehashi_logo.jpg" alt="">
                </div>
                <li><router-link to="/home">Home</router-link>
                <li v-if="user_activation"><router-link to="/nihom-type">Nihon</router-link>
                <li v-if="user_activation"><router-link to="/your-exam">Test Result</router-link>
                <li v-if="user_activation"><router-link to="/dictionary">Dictionary</router-link>
                <li v-if="user_activation"><router-link to="/change-pw">Setting</router-link>
                <li @click="logout"><a >Logout</a></li>
              </ul>
              <ul id="nav-mobile" class="right hide-on-med-and-down">
                <li><router-link to="/home">Home</router-link>
                <li v-if="user_activation"><router-link to="/nihom-type">Nihon</router-link>
                <li v-if="user_activation"><router-link to="/your-exam">Test Result</router-link>
                <li v-if="user_activation"><router-link to="/dictionary">Dictionary</router-link>
                <li v-if="user_activation"><router-link to="/change-pw">Setting</router-link>
                <li @click="logout"><a >Logout</a></li>
              </ul>
            </div>
    </nav>
    <!-- <sidebar></sidebar> -->
    </fragment>
</template>
<script>
import Sidebar from '@/components/Partials/Sidebar.vue';

export default {
    components: 
    {
        "sidebar":Sidebar,
    },
      mounted() {
   
    var elems = document.querySelectorAll('.sidenav');
    var instances = M.Sidenav.init(elems, {});
    
  },
  updated() {
   var elems = document.querySelectorAll('.sidenav');
    var instances = M.Sidenav.init(elems, {});
  },
  methods: {
    logout()
    {
      
       this.$store.dispatch("logout");
    }
  },
  computed: {
      user_activation()
      {
          return this.$store.getters.user_activation;
      }
  },
}
</script>
<style lang="scss" scoped>
        @import url('https://fonts.googleapis.com/css?family=Quicksand&display=swap');
        @import "@/style/colors.scss";

        nav 
        {
          background: $primaryColor;
          height:50px;
          line-height: 50px;
          padding-left:20%;
          padding-right:25%;
            // background: rgb(65,237,143);
            // background: linear-gradient(93deg, rgba(65,237,143,1) 4%, rgba(0,129,78,1) 89%);
        }

        nav li
        {
          padding-right:20px;
          padding-left:20px;
        }

        nav li a 
        {
             font-family: 'Quicksand', sans-serif;
        }

        .brand-logo 
        {
            color:white;
            font-weight:normal;
            font-size:18px;
            background:#e38b00;
            padding:0px 10px 0px 10px;
        }


        #mobile-demo
        {
            width:300px;
            .banner 
            {
              padding-top:20px;
              padding-bottom:20px;
              height:140px;
              background:$primaryColor;
              display:flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              img 
              {
                width:100px;
                height:100px;
              }

            }
        }

        @media only screen and (max-width: 1200px) {
          nav 
        {
          
          padding-left:10%;
          padding-right:10%;
            // background: rgb(65,237,143);
            // background: linear-gradient(93deg, rgba(65,237,143,1) 4%, rgba(0,129,78,1) 89%);
        }

        }

      

</style>